export default "__VITE_ASSET__Dw3jI_JR__"